import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class RightAngledTriangleConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'base',
			'height',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {
		return {
			base: maximum_rectangle.get_length(),
			height: maximum_rectangle.get_width(),
		};
	}

	get_labels(): Record<string, string> {
		const { width, height } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			width,
			height,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			base: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			height: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'straight';
	}
}
